import { debugToolsEnabled } from '@/ett-debug-tools'
import { AI_DEBUG_CHANNEL, type LlmCallMeta } from './llm-call-meta'

/**
 * Imperative emit for the `ai` debug channel, for non-React call sites (e.g.
 * the analyst SSE parser in tool-executor). Mirrors `useDebug`'s emit but
 * without a hook: gated on `debugToolsEnabled` (statically false in prod, so
 * the dynamic registry import is dead-code eliminated) and keyed by `key` so a
 * caller can group a run's rounds under one sidebar tab.
 */
export function emitAiDebugRound(key: string, meta: LlmCallMeta): void {
  if (!debugToolsEnabled) return
  void import('@/ett-debug-tools/registry').then(({ debugRegistry }) => {
    try {
      debugRegistry.emit(AI_DEBUG_CHANNEL, key, meta)
    } catch (err) {
      console.warn('[ai-debug] emit failed', err)
    }
  })
}
